class AnnouncementBar extends HTMLElement {
  #observer = new ResizeObserver(() => this.#build());
  #onSelect = () => this.setAttribute('data-selected', '');
  #onDeselect = () => this.removeAttribute('data-selected');

  connectedCallback() {
    this.#observer.observe(this);
    const group = this.querySelector('.announcement-bar__group');
    if (group) this.#observer.observe(group);
    this.addEventListener('shopify:block:select', this.#onSelect);
    this.addEventListener('shopify:block:deselect', this.#onDeselect);
    document.fonts.ready.then(() => {
      if (this.isConnected) this.#build();
    });
  }

  disconnectedCallback() {
    this.#observer.disconnect();
    this.removeEventListener('shopify:block:select', this.#onSelect);
    this.removeEventListener('shopify:block:deselect', this.#onDeselect);
  }

  #build() {
    const track = this.querySelector('.announcement-bar__track');
    const group = track?.firstElementChild;
    if (!track || !group) return;
    track.querySelectorAll('[data-marquee-copy]').forEach((copy) => copy.remove());
    const width = group.getBoundingClientRect().width;
    if (!width || !this.clientWidth) {
      track.removeAttribute('data-ready');
      return;
    }
    const copies = Math.ceil(this.clientWidth / width) + 1;
    for (let i = 0; i < copies; i++) {
      const copy = group.cloneNode(true);
      copy.setAttribute('data-marquee-copy', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('inert', '');
      copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('id');
        element.removeAttribute('data-shopify-editor-block');
      });
      track.append(copy);
    }
    const seconds = Number(this.dataset.speed) || 5;
    track.style.setProperty('--marquee-distance', width + 'px');
    track.style.setProperty('--marquee-duration', width / (150 / seconds) + 's');
    track.setAttribute('data-ready', '');
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
